export default class TranslationService {
  
  private _textMap: Map<string, string>;

  constructor(textMap: Map<string, string>) {
    this._textMap = textMap;
  }
  
  public getValue(key: string): string {

    if(this._textMap.has(key)) {
      return this._textMap.get(key) as string;
    }
    return key;
  }
}
